export default __webpack_public_path__ + "static/media/pencil.ff1fc2da.svg";